import {format} from 'date-fns';
import {de, enUS} from 'date-fns/locale';
import {i18n} from '@/plugins/i18n';

export const monthFilter = (date) => {
  return format(new Date(date), 'MMMM yyyy', {
    locale: i18n.locale === 'en' ? enUS : de,
  });
};
